module.exports = __webpack_public_path__ + "img/cancel.e197ef55.png";